import {Avatar,Badge,Toolbar,Typography,Box,IconButton,Menu,Tooltip,MenuItem} from "@mui/material";
import React, { useEffect, useState } from "react";
import MarkunreadIcon from '@mui/icons-material/Markunread';
import Logo from '../assets/pat_3.png';
import Photo from '../assets/avatar-r.png';
import { useHistory } from 'react-router-dom';

const mystyle = {
    display: "flex",
    gap: "20px",
    alignItems: "center",
};
const usericon = {
    width: "30px",
    height: "30px",
};


export const Header = () => {
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };


  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const history = useHistory();

  const handleLogout = () => {
    localStorage.removeItem('session_id');
    localStorage.removeItem('user');
    history.push('/login');
    window.location.reload();
  };
  const userDataString = localStorage.getItem('user');
  const userData = userDataString ? JSON.parse(userDataString) : null;
  const userEmail = userData ? userData.user.email : null;
    return (
<>
        <div>
           <a href="http://infind.ai">
             <img height='100px' src={Logo} alt="logo" />
            </a>
        </div>

        <div style={mystyle} >
            <a  style={{
          color: "#1976d2",
          textDecoration: "underline",
          cursor:"pointer"
        }} href="https://docs.google.com/forms/d/1RUoi6uILyovANI97WAXwu5HZmwXA7DxfFyCg5rLPZQo/viewform?edit_requested=true" target="_blank" rel="noopener noreferrer">
          <span>Provide FeedBack</span></a>

              <Badge badgeContent={4} color="error">
                 <MarkunreadIcon />
              </Badge>
              <Toolbar disableGutters>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
               <Avatar style={usericon} src={Photo} alt="Remy Sharp"></Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
                <MenuItem  onClick={handleCloseUserMenu}>
                  <Typography textAlign="center" >{userEmail}</Typography>
                </MenuItem>
                <MenuItem  onClick={handleCloseUserMenu}>
                <Typography textAlign="center" onClick={handleLogout}>Logout</Typography>
                 
                </MenuItem>
                
            </Menu>
          </Box>
          </Toolbar>
        </div>
	
        </>
    );

};